<template>
<v-card>
    <div class="timeline">
      <div class="timeline-day" v-for="day in timelineData" :key="day.date">
        <div class="day-label">{{ day.date }}</div>
        <div class="events">
          <div
            v-for="event in day.events"
            :key="event.name"
            :class="`event ${event.color}`"
            :title="event.name"
          >
            {{ event.name }}
          </div>
        </div>
      </div>
    </div>
</v-card>
  </template>
  
  <script>
  export default {
    data() {
      return {
        timelineData: [
          {
            date: "1 Feb",
            events: [
              { name: "Consulta", color: "blue" },
              { name: "Técnico Administrativo", color: "yellow" },
            ],
          },
          {
            date: "2 Feb",
            events: [{ name: "Sala de Hemodiálisis", color: "green" }],
          },
        ],
      };
    },
  };
  </script>
  
  <style>
  .timeline {
    display: flex;
    overflow-x: scroll;
  }
  .timeline-day {
    flex: 0 0 auto;
    width: 150px;
    border: 1px solid #ccc;
    padding: 10px;
  }
  .event {
    margin: 5px 0;
    padding: 5px;
    color: white;
    border-radius: 5px;
  }
  .event.blue {
    background-color: blue;
  }
  .event.green {
    background-color: green;
  }
  .event.yellow {
    background-color: yellow;
  }
  </style>